import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { environment } from "src/environments/environment"
import { Observable } from "rxjs"
import { RedirectSchool } from "@app/shared/interfaces/redirect-school"

@Injectable()
export class SsoService {
  constructor(private httpClient: HttpClient) {}

  GoToSchool(tenantId: string): Observable<RedirectSchool> {
    return this.httpClient.get<RedirectSchool>(
      environment.endpointLexSso.url +
        environment.endpointLexSso.routes.impersonate +
        tenantId
    )
  }
}
